<template>
    <divBox class="trajectory-right">
        <el-form ref="ruleForm" label-width="70px" :model="formLabelAlign">
            <el-form-item label="时间">
                <el-date-picker
                    v-model="formLabelAlign.pickerTime"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="区域：">
                <el-cascader
                    filterable
                    ref="address"
                    :options="optionsCity"
                    v-model="formLabelAlign.province"
                    clearable
                    @change="onCityChange"
                    :props="{ value: 'id', label: 'name'}">
                </el-cascader>
                <!-- <el-select width="100%" v-model="formLabelAlign.region" placeholder="请选择活动区域">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                </el-select> -->
            </el-form-item>
            <el-form-item label="车牌号：">
                <el-select v-model="formLabelAlign.licensePlate" placeholder="请选择车牌"
                    @change="onPlateChange">
                    <el-option
                        v-for="(item, i) in plateList"
                        :key="'plateList' + i"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                    <!-- <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option> -->
                </el-select>
            </el-form-item>
            <el-form-item class="butttons" label="">
                <el-button class="reset" @click="resetForm('ruleForm')">重置</el-button>
                <span></span>
                <el-button class="submit" @click="valiForm('ruleForm')">查询</el-button>
            </el-form-item>
        </el-form>
    </divBox>
</template>

<script>
import divBox from '../../components/divBox.vue'
import { dataInterface } from '@/api/dataInterfaceApi'
let formLabelAlign = '{\
        "province": "",\
        "licensePlate": "",\
        "pickerTime": ""\
    }'
export default {
    components: {
        divBox
    },
    data() {
        return {
            optionsCity: [],
            formLabelAlign: JSON.parse(formLabelAlign),
            plateList: []
        }
    },
    mounted() {
        this.provincesList()
    },
    methods: {
        provincesList () {
            dataInterface.provincesList().then(res => {
                this.optionsCity = res || []
            })
        },
        // 城市区选择
        onCityChange (e) {
            if (e[0] != undefined) {
                this.formLabelAlign.province = e[0] + ',' + e[1]
            }
            console.log('这是什么值', this.formLabelAlign.province)
            // debugger
            this.getVehicleLicenseList()
        },
        // 查询车牌
        getVehicleLicenseList() {
            let cityId = this.formLabelAlign.province?.split(',')[1] || ''
            let params = {
                "enCode": "rxslc_VehicleLicenseList",
                "@networkAccess": cityId
            }
            this.plateList = []
            dataInterface
                .dataFaceApi(params)
                .then((res) => {
                    console.log('=========', res)
                    if(!res || !res.length) return
                    // resolve(res[0])
                    this.plateList = res.map( item => {
                        return {
                            label: item.license_plate,
                            value: item.vehicle_vin
                        }
                    })
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        // 选择车辆
        onPlateChange(e) {
            console.log('选择车辆: ', this.formLabelAlign.licensePlate)
        },
        // 验证 表单
        valiForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert('submit!')
                    this.$emit('search', this.formLabelAlign)
                    console.log('valiForm', this.formLabelAlign)
                    // return
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        // 重置
        resetForm() {
            this.formLabelAlign = JSON.parse(formLabelAlign)
        }
    }
}
</script>

<style lang="scss" scoped>
.trajectory-right {
    padding: 50px 25px 25px;
    font-size: 20px;
    display: flex;
    height: 400px;
    .butttons {
        .reset, .submit{
            height: 60px;
            box-shadow: 0px 2px 2px 0px rgba(146,146,146,0.19);
        }
        .reset {
            background: linear-gradient(#D9D9D9 1%, #d1d1d1 60%);
            color: #494A4A;
        }
        .submit {
            background: linear-gradient(#0E868B 1%, #002B29 60%);
            color: #fff;
        }
    }
    ::v-deep .el-form-item__content {
        display: flex;
        // width: 100%;
        height: 60px;
        line-height: 60px;
        > span {
            flex-shrink: 0;
            width: 10px;
        }
        > button {
            flex: 1;
            border: none;
        }
        .el-input__inner {
            background: rgba(0,0,0,0.45);
            border: none;
            color: #fff;
            height: 60px;
            line-height: 60px;
            > input {
                background: none;
                color: #fff;
            }
        }
        .el-cascader {
            width: 100%;
        }
    }
    ::v-deep .el-form-item__label {
        color: #fff;
        font-size: 20px;
        height: 60px;
        line-height: 60px;
    }
    ::v-deep .el-select {
        width: 100%;
        background: rgba(0,0,0,0.45);
        .el-input__inner {
            height: 60px;
            line-height: 60px;
            background: rgba(0,0,0,0.45);
            border: none;
            color: #fff;
        }
    }
}
</style>